import ApiService from '../../../../../services/ApiService'
import SignatureScreen from '../../../../../components/SignatureScreen.vue'
import utils from '../../../../../Utils/FormatDate'
import moment from 'moment'

export default {
  props: {
    equipment: Object,
    dialogVisible: Boolean,
    serviceOrder: Object,
  },

  components: {
    SignatureScreen,
  },

  created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.getInfo()
  },

  data: () => ({
    loading: false,
    equipmentId: 0,
    accessories: [],
    equipmentIntegrity: '',
    soundAndLightVerification: '',
    cableAndSupply: '',
    printingMechanism: '',
    accessoryIntegrity: '',
    functionalTests: '',
    generalCleaning: '',
    observations: '',
    acessoriesRelation: [
      {
        description: '',
        quantity: '',
        code: '',
      },
      {
        description: '',
        quantity: '',
        code: '',
      },
      {
        description: '',
        quantity: '',
        code: '',
      },
    ],
    selectedImage: '',
    signImage: '',
    option: 0,
    signatureConfirmDialog: false,
    signImagePath: '',
    validatorName: '',
    option: null,
    user: {},
    step: 0,
    errorMessage: '',
    menuAlienationDate: false,
    loading: false,
    firstValid: false,
    acceptanceDialog: false,
    error: false,
    dialog: false,
    confirmDialog: false,
    alienationDate: null,
    alienated: false,
    levels: [
      'Auxiliar',
      'Coordenador',
      'Enfermeiro',
      'Engenheiro',
      'Estagiário',
      'Recepcionista',
      'Supervisor',
      'Técnico',
      'Farmacêutico',
      'Fisioterapeuta',
      'Administrativo',
      'Gerente',
      'Nutricionista',
    ],
    institution: {},
    technicalReport: null,
    currentEquipment: {
      id: 0,
      alienated: false,
      alienationMotive: '',
      alienationDate: null,
    },
    alienationMotiveRules: [
      (v) => currentEquipment.alienated || !!v || 'Motivo requerido',
    ],
    alienationDateRules: [
      (v) => currentEquipment.alienated || !!v || 'Data da alienação requeirda',
    ],
    apiService: new ApiService(),
  }),

  computed: {
    buttonText() {
      switch (this.step) {
        case 0:
          return this.currentEquipment.alienated ? 'Desalienar' : 'Alienar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    formatDate(date) {
      if (date) return moment(date).format('DD/MM/yyyy')
      return ''
    },

    addRelation() {
      this.acessoriesRelation.push({
        description: '',
        quantity: '',
        code: '',
      })
    },

    removeRelation(index) {
      this.acessoriesRelation.splice(index, 1)
    },

    picImage() {
      document.getElementById('fileinput').click()
    },

    setImage(image) {
      if (image.size > 2000000) {
        this.$toast.warning(
          'Só é permitido envio de imagens com no máximo 2mb!'
        )
      } else {
        const reader = new FileReader()
        reader.readAsDataURL(image)
        reader.onload = () => {
          this.selectedImage = reader.result
        }
      }
    },

    sign(data) {
      if (this.option == 0) {
        if (this.user.signatureImage) {
          if (
            this.user.signatureImage.includes(
              'https://equipacarefix.blob.core.windows.net/'
            )
          ) {
            this.signImage = this.user.signatureImage
            this.signImagePath = this.user.signatureImage
          } else {
            this.signImage = `wwwroot/Uploads/Users/${this.user.id}/signatureImage`
            this.signImagePath = `${process.env.VUE_APP_BASE_URL}Uploads/Users/${this.user.id}/signatureImage/${this.user.signatureImage}`
          }

          this.signatureConfirmDialog = false
        } else {
          this.$toast.error(
            'Assinatura não encontrada, verifique se existe uma assinatura cadastrada em seu usuário'
          )
        }
      } else {
        this.signImage = data
        this.signImagePath = data
        this.signatureConfirmDialog = false
      }
    },

    async getInfo() {
      await this.apiService
        .get(`equipment/info/${this.serviceOrder.equipmentId}`)
        .then((response) => {
          this.currentEquipment = response.content
          this.currentEquipment.haveContract =
            !!this.currentEquipment.contractId
        })
    },

    close() {
      this.$emit('close')
    },

    async next() {
      if (this.step === 0) {
        if (this.$refs.firstForm.validate()) {
          this.dialog = true
        }
      } else {
        this.close()
      }
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatInitialDate(dateInitial) {
      const date = new Date(dateInitial),
        day = date.getDate().toString(),
        dayF = day.length == 1 ? '0' + day : day,
        month = (date.getMonth() + 1).toString(),
        monthF = month.length == 1 ? '0' + month : month,
        yearF = date.getFullYear()
      return `${dayF}-${monthF}-${yearF}`
    },

    save(date) {
      this.alienationDate = this.formatInputDate(
        this.currentEquipment.alienationDate
      )
      this.$refs.menuAlienationDate.save(date)
    },

    alienateEquipment() {
      if (this.currentEquipment.alienated) {
        this.submit()
      } else {
        this.dialog = false
        this.confirmDialog = true
      }
    },

    async submit() {
      if (!this.$refs.firstForm.validate()) return

      const payload = {
        equipmentId: this.currentEquipment.id,
        accessories: this.acessoriesRelation,
        checklist: {
          equipmentIntegrity: this.equipmentIntegrity,
          soundAndLightVerification: this.soundAndLightVerification,
          cableAndSupply: this.cableAndSupply,
          printingMechanism: this.printingMechanism,
          accessoryIntegrity: this.accessoryIntegrity,
          functionalTests: this.functionalTests,
          generalCleaning: this.generalCleaning,
          observations: this.observations,
        },
        technicalReport: this.technicalReport,
        validatorSign: this.signImage,
        validatorName: this.validatorName ? this.validatorName : this.user.name,
        validatorJob: this.levels[this.institution.userOffice],
        serviceOrderId: this.serviceOrder.id,
      }

      this.loading = true

      try {
        await this.apiService
          .post('Acceptance/generateAcceptancePdf', payload)
          .then((response) => {
            window.open(response.content, '_blank')
            this.$toast.success('Formulário salvo com sucesso!')
            this.$emit('close')
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      } catch (error) {
        console.error('Erro ao enviar o checklist:', error)
        this.$toast.error('Erro ao enviar checklist')
      }
    },
  },
}
